var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('v-avatar',{attrs:{"size":"20"}},[_c('img',{attrs:{"src":_vm.media.src,"alt":_vm.media.name}})]),_vm._v(" "+_vm._s(_vm.name)+" "),_c('v-icon',{attrs:{"dense":""},on:{"click":_vm.clickDelete}},[_vm._v("mdi-close-circle-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }